import React from "react"
import {makeStyles} from "@material-ui/core/styles"
import classNames from "classnames"
import PropTypes from "prop-types"

import styles from '../../styles/jss/components/cardIconStyle'

const useStyles = makeStyles(styles)

export default function CardIcon(props) {
  const classes = useStyles()
  const { className, children, color, ...rest } = props
  const cardIconClasses = classNames({
    [classes.cardIcon]: true,
    [classes[color + "CardHeader"]]: color,
    [className]: className !== undefined
  })

  return (
    <div className={cardIconClasses} {...rest}>
      {children}
    </div>
  )
}

CardIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf([
    "warning",
    "success",
    "danger",
    "info",
    "primary",
    "rose",
    "red",
    "orange",
    "yellow",
    "green",
    "blue",
    "purple",
    "brown"
  ]),
  children: PropTypes.node
}
